import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/element/button";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Form, Formik } from "formik";
import useWindowDimensions from "../../../components/hook/use.window.dimensions";
import InputCount from "../../../components/element/input.count";
import {
  closeConfirmModal,
  openAccessoriesModal,
  openConfirmModal,
  openEditPriceModal,
} from "../../../redux/reducer/modalReducer";
import { useEffect, useRef, useState } from "react";
import {
  clearCart,
  createOrder,
  getCartInfo,
  getOrderList,
  removeCart,
  setCartItemLoading,
  setSelectedCartItem,
  updateCart,
} from "../../../redux/reducer/cartOrderReducer";
import {
  clearAccessoriesInfo,
  getProductInfo,
} from "../../../redux/reducer/serviceReducer";
import * as Yup from "yup";
import {
  getCartCount,
  getDropdownModel,
  getUserRole,
  setConfirmData,
} from "../../../redux/reducer/commonReducer";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../components/common/common.toast";
import { DefaultJustint } from "../../../assets/images";
import Lottie from "lottie-react";
import { Empty, Loading } from "../../../assets/lotties";
import formatNumber from "../../../helpers/format.number";
import {
  getSentHistory,
  setActivePage,
  setDate,
  setSearch,
} from "../../../redux/reducer/promotionReducer";
import ReactPaginate from "react-paginate";

export const TotalPriceRow = ({ cartInfo, loading, buttonTitle }) => {
  // const handleNext = () => {
  //   const nextSection = document.getElementById("customer-details");
  //   if (nextSection) {
  //     nextSection.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // };
  // return (buttonTitle === "Next" && cartInfo?.total_item > 0) ||
  //   buttonTitle !== "Next" ? (
  //   <section className="total-price-row">
  //     <article className="flex items-end gap-4">
  //       <p>Total ({sentHistory?.length} Items)</p>
  //       <h6>
  //         &nbsp; RM {isNaN(cartInfo?.total) ? 0 : formatNumber(cartInfo?.total)}
  //       </h6>
  //     </article>
  //     <Button
  //       disabled={!cartInfo || cartInfo?.total_item === 0 || loading}
  //       btnClassName="common-button --without-icon"
  //       type={buttonTitle === "Next" ? "button" : "submit"}
  //       onClick={() => (buttonTitle === "Next" ? handleNext() : "")}
  //     >
  //       {buttonTitle}
  //     </Button>
  //   </section>
  // ) : (
  //   <></>
  // );
};

export default function SentBody() {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const { role } = useSelector((state) => state.common);
  const { sentHistory, sentHistoryLoading, date, search, activePage } =
    useSelector((state) => state.promotion);

  const [total, setTotal] = useState(0);

  const handlePageClick = (event) => {
    dispatch(setActivePage(event.selected));
  };

  useEffect(() => {
    setTotal(0);
    dispatch(setActivePage(0));
    dispatch(setSearch(""));
    dispatch(setDate([]));
  }, []);

  useEffect(() => {
    if (role === "agent") {
      dispatch(
        getSentHistory({
          start: activePage * 10,
          length: 10,
          search: search,
          startDate: date.length > 0 ? date[0] : "",
          endDate: date.length > 0 ? date[1] : "",
        })
      )
        .unwrap()
        .then((res) => {
          setTotal(res.data.iTotalDisplayRecords);
        });
    }
  }, [role, activePage, date, search]);

  return (
    <section className="sent-body">
      <article className="sent-list">
        {!sentHistoryLoading ? (
          sentHistory?.length > 0 ? (
            sentHistory.map((history, historyIndex) => {
              return (
                <article
                  className={`sent-row ${history.remark ? "--remark" : ""}`}
                >
                  <section className="sent-grid" key={historyIndex}>
                    {width > 550 ? (
                      <>
                        <p
                          className={
                            width > 660 ? "ps-5 text-start" : "text-center"
                          }
                        >
                          {history.created_at}
                        </p>
                        <p className="text-center">{history.phone_number}</p>
                        <p className="text-center two-line">
                          {history.voucher?.name}
                        </p>
                        <p className="text-center">{history.used_at ?? "-"}</p>
                      </>
                    ) : (
                      <>
                        <p className="text-center">
                          Sent at:&nbsp;&nbsp;&nbsp;{history.created_at}
                        </p>
                        <p className="text-center">
                          Send to:&nbsp;&nbsp;{history.phone_number}
                        </p>
                        <p className="text-center two-line">
                          Voucher:&nbsp;&nbsp;{history.voucher?.name}
                        </p>
                        <p className="text-center">
                          Used at:&nbsp;&nbsp;{history.used_at ?? "-"}
                        </p>
                        <p className="text-center">
                          Remark:&nbsp;&nbsp;{history.remark ?? "-"}
                        </p>
                      </>
                    )}
                  </section>
                  {width > 550 && history.remark && (
                    <article
                      className={`fyi --no-border ${
                        width > 660 ? "ms-5 me-5" : ""
                      } mt-3`}
                    >
                      <article>
                        <Icon icon="eva:info-outline" />
                      </article>
                      <p className="text-start">
                        <span>Remark:</span> {history.remark}
                      </p>
                    </article>
                  )}
                </article>
              );
            })
          ) : (
            <article className="w-100 minh-480 flex flex-column items-center">
              <article className="common-lottie --empty">
                <Lottie loop={2} animationData={Empty} />
              </article>
              <h6 className="--loading text-center"> No sent record found</h6>
            </article>
          )
        ) : (
          <article className="w-100 minh-480 flex flex-column items-center">
            <article className="common-lottie">
              <Lottie animationData={Loading} />
            </article>
            <h6 className="--loading text-center">Loading ..</h6>
          </article>
        )}
        {!sentHistoryLoading && total > 0 && (
          <ReactPaginate
            previousLabel={
              <Icon icon="weui:back-filled" className="--previous" />
            }
            nextLabel={<Icon icon="weui:back-filled" className="--next" />}
            breakLabel={"..."}
            pageCount={Math.ceil(total / 10)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            activeClassName={"active"}
            forcePage={activePage}
          />
        )}
        {/* <TotalPriceRow cartInfo={cartInfo} buttonTitle="Next" /> */}
      </article>
    </section>
  );
}
